/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.26.0 of "Temporary Messages"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { PublicAllActiveMessagesResponse } from '../models/PublicAllActiveMessagesResponse';
import type { UserType } from '../models/UserType';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class PublicService {

    /**
     * Get all (active) temporary messages that were not closed by the user.
     * @returns PublicAllActiveMessagesResponse The list of all active, unclosed temporary messages for the given user.
     *
     * @throws ApiError
     */
    public static getPublicTemporaryMessages({
        xApplicationType,
        xApplicationOsVariant,
        userType,
    }: {
        /**
         * Describes the responsible client application for a particular call
         *
         */
        xApplicationType: 'george-android' | 'george-ios' | 'george-web' | 'gbusiness-android' | 'gbusiness-ios' | 'gbusiness-web',
        /**
         * More detailed information about the client application platform, eg. if normal Android or Huawei
         *
         */
        xApplicationOsVariant?: 'Android' | 'Huawei' | 'Unknown',
        /**
         * The `userType` used for filtering.
         * If missing, `REGULAR` is assumed as the user type.
         *
         */
        userType?: UserType
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicTemporaryMessages({
        xApplicationType,
        xApplicationOsVariant,
        userType,
    }: {
        /**
         * Describes the responsible client application for a particular call
         *
         */
        xApplicationType: 'george-android' | 'george-ios' | 'george-web' | 'gbusiness-android' | 'gbusiness-ios' | 'gbusiness-web',
        /**
         * More detailed information about the client application platform, eg. if normal Android or Huawei
         *
         */
        xApplicationOsVariant?: 'Android' | 'Huawei' | 'Unknown',
        /**
         * The `userType` used for filtering.
         * If missing, `REGULAR` is assumed as the user type.
         *
         */
        userType?: UserType
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PublicAllActiveMessagesResponse>;
    public static getPublicTemporaryMessages({
        xApplicationType,
        xApplicationOsVariant,
        userType
    }: {
        /**
         * Describes the responsible client application for a particular call
         *
         */
        xApplicationType: 'george-android' | 'george-ios' | 'george-web' | 'gbusiness-android' | 'gbusiness-ios' | 'gbusiness-web',
        /**
         * More detailed information about the client application platform, eg. if normal Android or Huawei
         *
         */
        xApplicationOsVariant?: 'Android' | 'Huawei' | 'Unknown',
        /**
         * The `userType` used for filtering.
         * If missing, `REGULAR` is assumed as the user type.
         *
         */
        userType?: UserType,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/temporary-messages',
            query: {
                'userType': userType,
            },
            headers: {
                'X-Application-Type': xApplicationType,
                'X-Application-OS-Variant': xApplicationOsVariant,
            },
            errors: {
                400: `Common \`400 Bad Request\` problem responses for public endpoints.
                `,
            },
        });
    }

    /**
     * Mark a temporary message as read
     * Note: This HTTP method and API is needed for backwards compatibility with the API that BackOffice provided.
     *
     * @returns void
     * @throws ApiError
     */
    public static postPublicTemporaryMessagesClosed({
        id,
    }: {
        /**
         * The `id` of the temporary message.
         *
         */
        id: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postPublicTemporaryMessagesClosed({
        id,
    }: {
        /**
         * The `id` of the temporary message.
         *
         */
        id: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
    public static postPublicTemporaryMessagesClosed({
        id
    }: {
        /**
         * The `id` of the temporary message.
         *
         */
        id: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/temporary-messages/closed/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Common \`400 Bad Request\` problem responses for public endpoints.
                `,
                404: `The temporary message with the specified ID was not found.`,
            },
        });
    }

}
